<div class="pa-1" fxLayout="column" fxLayoutAlign="center center">
  <ng-container *ngIf="!isRated; else tplRated">
    <h3>{{ 'call_quality_evaluation.text_info'|translate }}</h3>
    <star-rating [value]="0" [totalstars]="5" checkedcolor="#0ed7a5" uncheckedcolor="#e4f6f8" size="30px" [readonly]="false"
      (rate)="onRate($event)"></star-rating>
  </ng-container>
  <ng-template #tplRated>
    <h3>{{ 'call_quality_evaluation.thank_for_rate'|translate }}</h3>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
      <span class="rate-value">{{ ratedValue }}</span>
      <star-rating [value]="1" [totalstars]="1" checkedcolor="#0ed7a5" uncheckedcolor="#e4f6f8" size="30px" [readonly]="true">
      </star-rating>
    </div>
  </ng-template>
</div>
